// extracted by mini-css-extract-plugin
export default {"container":"MorePanel_container__1DPLi","panel":"MorePanel_panel__BHNEg","open":"MorePanel_open__m1NUu","arrow":"MorePanel_arrow__njYD+","item":"MorePanel_item__x7Q+D"};